import http from "@/http/aisea/axios";

const resource = "/enterprise/public";

export default {

  get(id) {
    return http.get(`${resource}/${id}`);
  },

};
